(function () {
    const section = document.querySelector('[data-collection-section]');
    if (!section) return;

    const filters = section.querySelector('[data-filters]');
    const overlay = section.querySelector('[data-filter-overlay]');
    const loadingIndicator = section.querySelector('[data-loading-indicator]');
    const sectionNodes = {
        grid: section.querySelector('[data-collection-grid]'),
        count: section.querySelector('[data-collection-count]'),
        filtersInner: section.querySelector('[data-collection-filters-inner]'),
        sortSelect: section.querySelector('[data-sort-select]'),
    };

    const refreshSectionNodes = () => {
        sectionNodes.grid = section.querySelector('[data-collection-grid]');
        sectionNodes.count = section.querySelector('[data-collection-count]');
        sectionNodes.filtersInner = section.querySelector('[data-collection-filters-inner]');
        sectionNodes.sortSelect = section.querySelector('[data-sort-select]');
    };

    const getScrollAnchor = () => section.querySelector('.eeg-collection__hero') || sectionNodes.grid || section;

    const getDefaultSortBy = () => {
        if (!sectionNodes.sortSelect) return null;
        const defaultSort = sectionNodes.sortSelect.getAttribute('data-default-sort');
        if (!defaultSort) return null;
        return defaultSort;
    };

    const setLoading = (isLoading) => {
        if (sectionNodes.grid && isLoading) {
            const gridHeight = sectionNodes.grid.getBoundingClientRect().height;
            if (gridHeight > 0) {
                sectionNodes.grid.style.minHeight = `${gridHeight}px`;
            }
        }

        section.classList.toggle('is-loading', isLoading);
        section.setAttribute('aria-busy', isLoading ? 'true' : 'false');
        if (loadingIndicator) {
            loadingIndicator.setAttribute('aria-hidden', isLoading ? 'false' : 'true');
        }
        if (sectionNodes.grid && !isLoading) {
            sectionNodes.grid.style.minHeight = '';
        }
    };

    const openFilters = () => {
        if (!filters) return;
        filters.classList.add('is-open');
        filters.setAttribute('aria-hidden', 'false');
        if (overlay) overlay.classList.add('is-open');
        document.body.classList.add('overlay-open');
    };

    const closeFilters = () => {
        if (filters) {
            filters.classList.remove('is-open');
            filters.setAttribute('aria-hidden', 'true');
        }
        if (overlay) overlay.classList.remove('is-open');
        document.body.classList.remove('overlay-open');
    };

    const buildFiltersUrl = () => {
        const params = new URLSearchParams();
        const sortSelect = sectionNodes.sortSelect;
        const defaultSortBy = getDefaultSortBy();
        if (sortSelect && sortSelect.value) {
            if (!defaultSortBy || sortSelect.value !== defaultSortBy) {
                params.set('sort_by', sortSelect.value);
            }
        }

        if (filters) {
            const checkboxes = filters.querySelectorAll('input[type="checkbox"]:checked:not([data-price-range])');
            checkboxes.forEach((cb) => {
                params.append(cb.name, cb.value);
            });

            const priceChoice = filters.querySelector('[data-price-range]:checked');
            if (priceChoice) {
                const minParam = priceChoice.getAttribute('data-min-param');
                const maxParam = priceChoice.getAttribute('data-max-param');
                const minValue = priceChoice.getAttribute('data-min-value');
                const maxValue = priceChoice.getAttribute('data-max-value');

                if (minParam && minValue) {
                    params.set(minParam, minValue);
                }

                if (maxParam && maxValue) {
                    params.set(maxParam, maxValue);
                }
            }
        }

        const query = params.toString();
        if (query) {
            return `${window.location.pathname}?${query}`;
        }
        return window.location.pathname;
    };

    const normalizePriceValue = (value) => {
        if (value === null || value === '') return null;
        const numberValue = Number(value);
        if (Number.isNaN(numberValue)) return null;
        if (numberValue === 0) return null;
        return numberValue;
    };

    const syncPriceSelectionFromUrl = () => {
        const priceRanges = section.querySelectorAll('[data-price-range]');
        if (!priceRanges.length) return;
        const minParam = priceRanges[0].getAttribute('data-min-param');
        const maxParam = priceRanges[0].getAttribute('data-max-param');
        if (!minParam && !maxParam) return;
        const url = new URL(window.location.href);
        const minValue = normalizePriceValue(minParam ? url.searchParams.get(minParam) : null);
        const maxValue = normalizePriceValue(maxParam ? url.searchParams.get(maxParam) : null);

        let matched = false;
        priceRanges.forEach((range) => {
            const rangeMin = normalizePriceValue(range.getAttribute('data-min-value'));
            const rangeMax = normalizePriceValue(range.getAttribute('data-max-value'));
            const isMatch = rangeMin === minValue && rangeMax === maxValue;
            range.checked = isMatch;
            if (isMatch) matched = true;
        });

        if (!matched && minValue === null && maxValue === null) {
            priceRanges.forEach((range) => {
                range.checked = false;
            });
        }
    };

    const updateSection = (newSection) => {
        const newGrid = newSection.querySelector('[data-collection-grid]');
        if (sectionNodes.grid && newGrid) {
            sectionNodes.grid.innerHTML = newGrid.innerHTML;
        }

        const newCount = newSection.querySelector('[data-collection-count]');
        if (sectionNodes.count && newCount) {
            sectionNodes.count.innerHTML = newCount.innerHTML;
        }

        const newFiltersInner = newSection.querySelector('[data-collection-filters-inner]');
        if (sectionNodes.filtersInner && newFiltersInner) {
            sectionNodes.filtersInner.innerHTML = newFiltersInner.innerHTML;
        }

        const newSortSelect = newSection.querySelector('[data-sort-select]');
        refreshSectionNodes();

        if (sectionNodes.sortSelect && newSortSelect) {
            sectionNodes.sortSelect.value = newSortSelect.value;
            const defaultSort = newSortSelect.getAttribute('data-default-sort');
            if (defaultSort) {
                sectionNodes.sortSelect.setAttribute('data-default-sort', defaultSort);
            }
        }
    };

    const filterController = window.EEGFilterResultsController
        ? window.EEGFilterResultsController.create({
            section,
            sectionId: 'main-collection',
            sectionSelector: '[data-collection-section]',
            historyStateKey: 'collectionUrl',
            cacheLimit: 12,
            buildFiltersUrl,
            updateSection,
            setLoading,
            getScrollAnchor,
            closeFilters,
            onAfterUpdate: syncPriceSelectionFromUrl,
        })
        : null;

    const applyFilters = (options = {}) => {
        if (!filterController) {
            window.location.href = buildFiltersUrl();
            return;
        }
        filterController.applyFilters(options);
    };

    const fetchAndRender = (targetUrl, options = {}) => {
        if (!filterController) {
            window.location.href = targetUrl;
            return;
        }
        filterController.fetchAndRender(targetUrl, options);
    };

    const canAutoApply = window.EEGFilterResultsController
        ? window.EEGFilterResultsController.shouldAutoApply
        : () => window.matchMedia('(min-width: 990px)').matches;

    syncPriceSelectionFromUrl();

    if (window.EEGFilterResultsController && typeof window.EEGFilterResultsController.bindFilterUI === 'function') {
        window.EEGFilterResultsController.bindFilterUI({
            section,
            openFilters,
            closeFilters,
            applyFilters,
            fetchAndRender,
            shouldAutoApply: canAutoApply,
        });
    }

    window.addEventListener('popstate', () => {
        fetchAndRender(window.location.href, { pushState: false, scroll: false });
    });
})();
